import { AM } from "./antimatter";
import { AD } from "./antimatter-dimensions";
import { DT } from "./dilated-time";
import { eternities } from "./eternities";
import { EP } from "./eternity-points";
import { galaxies } from "./galaxies";
import { gamespeed } from "./gamespeed";
import { general } from "./general";
import { infinities } from "./infinities";
import { ID } from "./infinity-dimensions";
import { IP } from "./infinity-points";
import { replicanti } from "./replicanti";
import { TP } from "./tachyon-particles";
import { tickspeed, tickspeedUpgrades } from "./tickspeed";
import { TD } from "./time-dimensions";
import { hostScore } from "./score";

export const multiplierTabValues = {
  general,
  AM,
  AD,
  ID,
  TD,
  IP,
  EP,
  TP,
  DT,
  tickspeed,
  tickspeedUpgrades,
  galaxies,
  infinities,
  eternities,
  gamespeed,
  replicanti,
  hostScore
};
